<template>
  <div class="content">
    <div class="warning-block">
      <span class="text-red">＊</span>
      廠商對帳記錄表已搬至「
      <a @click="goto" class="cursor-pointer">新後台管理系統 > 財務中心 > 帳務明細</a>
      」，請至新後台管理系統檢視相關內容，此區域(舊後台)功能即將關閉。
    </div>
    <div class="box">
      <div class="box-body">
        <!-- Tab - Strat -->
        <div class="row m-b-10">
          <div class="tab">
            <ul class="nav nav-tabs flex" style="margin-bottom: 10px;">
              <li role="presentation" :class="{active: typeSelect === 99}">
                <a @click.prevent="typeSelect = 99">金流
                </a>
              </li>
              <li role="presentation" :class="{active: typeSelect === 1}">
                <a @click.prevent="typeSelect = 1">物流
                </a>
              </li>
              <li v-if="getRestricted.indexOf(900) !== -1" role="presentation" :class="{active: typeSelect === 10}">
                <a @click.prevent="typeSelect = 10">資訊服務費抽成
                </a>
              </li>
              <div class="m-l-auto flex">
                <div>
                  <button
                    class="btn btn-default btn-table-title z-100 h-38"
                    @click="download"
                    disabled
                  >
                    <i class="fa fa-download">下載報表</i>
                    <clip-loader class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'" />
                  </button>
                </div>
                <div>
                  <!--
                    歷史報表
                    1. 需選擇品牌
                    2. 門市權限若無勾選"門市獨立產出...對帳表" 則不顯示
                  -->
                  <button
                    v-if="showHistoryReport"
                    class="btn btn-default btn-table-title z-100 h-38 m-l-5"
                    :title="!brandSelect.value ? '請選擇品牌' : ''"
                    disabled
                    @click="goCommissionHistory"
                  >
                    歷史報表
                  </button>
                </div>
                <!--
                  米特儲值金查詢 (後端判斷)
                  Admin：全顯示
                  Brand：品牌下的門市有加入米特，則顯示
                  Store：選擇的門市有米特，且扣款對象為門市時，顯示
                -->
                <div v-if="typeSelect === 1 && shippingInfo.mete_portal_url">
                  <button
                    class="btn btn-default btn-table-title z-100 h-38 m-l-5"
                    @click="openLink"
                  >
                    查詢儲值金餘額
                  </button>
                </div>
                <!-- 物流 End -->
              </div>
            </ul>
          </div>
        </div>
        <!-- Tab - End -->

        <!-- 金流 - Start -->
        <div v-if="typeSelect === 99">
          <!-- 品牌與門市 - Start -->
          <div class="row">
            <div class="col-sm-8">
              <div v-if="brandBrief.length > 2 || storeBrief.length > 2" class="flex m-b-10">
                <div class="inline-block from-group pull-left " v-if="brandBrief.length > 2" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="==品牌=="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                  >
                  </multiselect>
                </div>
                <!-- 門市 -->
                <div :class="['inline-block from-group pull-left', {'m-l-5':brandBrief.length >2}]" v-if="storeBrief.length > 2" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="storeSelect"
                    :options="storeBrief"
                    label="label"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="門市"
                    :show-labels="false"
                    :preselect-first="true"
                  >
                  </multiselect>
            </div>
          </div>
          <!-- 品牌與門市 - End -->
          <div>
            <div class="flex">
            <div class="form-group">
              <!-- 交易類型(收款：1,退款：2) -->
              <select class="form-control h-38" v-model="accountingSelect" @change="changePage(1)">
                <option v-for="(type) in accountingList" :value="type.value">
                  {{type.label}}
                </option>
              </select>
            </div>
            <div class="form-group m-l-5">
              <!-- 付款類型(linepay, jkopay....) -->
              <select class="form-control h-38" v-model="tradeTypeSelect" @change="changePage(1)">
                <option v-for="trade in traceTypeOption" :value="trade.value">
                  {{trade.label}}
                </option>
              </select>
            </div>
            <div v-if="getRoleType === 99" class="form-group m-l-5">
              <!-- 報表類型 -->
              <select class="form-control h-38" v-model="reportSelect">
                <option :value="999">
                  == 報表類型 ==
                </option>
                <option :value="1">
                  原始報表
                </option>
                <option v-if="tradeTypeSelect === 713"  :value="2">
                  對外對帳單
                </option>
              </select>
            </div>
            <div class="h-38 m-l-5" style="width: auto; min-width: 150px;">
              <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
            </div>
            <div class="h-38 m-l-5" style="width: auto; min-width: 150px;">
              <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
            </div>
            <div class="m-l-5">
              <select class="form-control h-38" v-model="sourceSelect" @change="changePage(1)">
                <option :value="999">
                  == 訂單來源 ==
                </option>
                <option v-if="tradeTypeSelect === 908"  :value="5">
                  街口APP
                </option>
                <option :value="1">
                  你訂
                </option>
              </select>
            </div>
          </div>
          </div>
            </div>
            <div class="col-sm-4">
              <div class="m-l-auto flex" style="max-width: 340px;">
                <select class="form-control h-38">
                  <option value="2">訂單編號</option>
                </select>
                <div class="form-group h-38 m-l-5">
                  <div class="input-group h-38">
                    <input class="form-control h-38" v-model="orderSN" type="text" style="min-width: 150px;">
                    <span class="input-group-addon c-pointer" @click="changePage(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive p-x-0">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                    <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品牌名稱(ID)</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">門市名稱(ID)</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單編號</th>
                        <th v-if="reportSelect === 1 || reportSelect === 999" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單類型</th>
                        <th v-if="reportSelect === 1 || reportSelect === 999" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單狀態</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易日期
                          <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="訂單建立日期">
                            <i class="fa fa-question-circle" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款完成日</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">支付卡別</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">收單行</th>
                        <!-- <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">手續費</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">費率</th> -->
                        <th v-if="reportSelect === 1 || reportSelect === 999" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">折扣</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單總金額</th>
                        <th v-if="reportSelect === 1 || reportSelect === 999" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款類型</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易類型
                          <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="退款為已申請退款非完成退款">
                            <i class="fa fa-question-circle" aria-hidden="true"></i>
                          </span>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="isLoading">
                  <tr>
                    <td colspan="12" class="text-center">資料讀取中......</td>
                  </tr>
                </tbody>
                <tbody v-else-if="!isLoading && history.length > 0">
                    <tr v-for="(row, index) in history" :key="index" class="even" role="row">
                        <td class="sorting_1">
                            {{index + 1 }}
                        </td>
                        <td style="width: 200px">
                            {{row.brand_name}}({{row.brand_id}})
                        </td>
                        <td>
                            {{row.store_name}}({{row.store_id}})
                        </td>
                        <td>
                            {{row.order_sn}}
                        </td>
                        <td v-if="reportSelect === 1 || reportSelect === 999">
                            {{row.delivery_type | deliveryName}}
                        </td>
                        <td v-if="reportSelect === 1 || reportSelect === 999">
                            <label class="label" :class="row.order_status | orderStateColor">
                              {{row.order_status | orderStatusName}}
                            </label>
                        </td>
                        <td>
                            {{row.trade_date}}
                        </td>
                        <td>
                            {{row.trade_finish_date}}
                        </td>
                        <td>
                            <div v-html="creditCardType(row.card_type)"></div>
                        </td>
                        <td>
                            {{row.acquirer?row.acquirer:'-'}}
                        </td>
                        <!-- <td>
                            {{row.update_time}}
                        </td>
                        <td>
                            {{row.user_account}}
                        </td> -->
                        <td v-if="reportSelect === 1 || reportSelect === 999">
                            ${{row.total_money-row.total_paid_money}}
                        </td>
                        <td>
                            ${{row.total_paid_money}}
                        </td>
                        <td v-if="reportSelect === 1 || reportSelect === 999">
                            <label class="label" :class="tradeTypeColor(tradeType(row.trade_type))">{{tradeType(row.trade_type)}}</label>
                        </td>
                        <td>
                            <label class="label" :class="accountingType(row.accounting_type)">{{row.accounting_type===1?'收款':'退款'}}</label>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="!isLoading && history.length === 0">
                  <tr style="background-color: white">
                    <td rowspan="1" colspan="14" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                      <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                      <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
          <paginate
            :pageAmount="paymentPageAmount"
            :total="pagination.paymentFlow.total"
            :isActive="isActive"
            :groupAmount="pagination.paymentFlow.groupAmount"
            :clickPage="changePage"
          />
        </div>
        <!-- 金流 - End -->

        <!-- 物流 - Start -->
        <div v-if="typeSelect === 1">
          <!-- 品牌與門市 - Start -->
          <div class="row">
            <div class="col-sm-8">
              <div v-if="brandBrief.length > 2 || storeBrief.length > 2" class="flex m-b-10">
                <div class="inline-block from-group pull-left " v-if="brandBrief.length > 2" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="==品牌=="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                  >
                  </multiselect>
                </div>
                <!-- 門市 -->
                <div :class="['inline-block from-group pull-left', {'m-l-5':brandBrief.length >2}]" v-if="storeBrief.length > 2" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="storeSelect"
                    :options="storeBrief"
                    label="label"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="門市"
                    :show-labels="false"
                    :preselect-first="true"
                  >
                  </multiselect>
            </div>
            <div class="form-group m-l-5">
              <select
                class="form-control h-38"
                v-model="shippingVendorSelect"
                @change="changePage(1)"
              >
                <option
                  v-for="item in shippingVendorList"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- 品牌與門市 - End -->
          <div>
            <div class="flex">
              <div class="form-group">
                <select :disabled = "isLoading" class="form-control h-38" v-model="sourceType"  @change="changePage(1)">
                  <option v-for="order in sourceTypeList" :value="order.value" v-text="order.label" />
                </select>
              </div>
              <div class="form-group m-l-5">
                <select :disabled = "isLoading" class="form-control h-38" v-model="userType" @change="changePage(1)">
                  <option v-for="shopper in userTypeList" :value="shopper.value" v-text="shopper.label" />
                </select>
              </div>
              <div class="form-group m-l-5">
                <select
                  class="form-control h-38"
                  v-model="orderStatus"
                  @change="changePage(1)"
                >
                  <option
                    v-for="item in orderStatusList"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>
              <div class="form-group m-l-5">
                <select
                  class="form-control h-38"
                  v-model="shippingStatus"
                  @change="changePage(1)"
                >
                  <option
                    v-for="item in shippingStatusList"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>
              <div class="h-38 m-l-5" style="width: auto; min-width: 150px;">
                <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
              </div>
              <div class="h-38 m-l-5" style="width: auto; min-width: 150px;">
                <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
              </div>
            </div>
          </div>
            </div>
            <div class="col-sm-4">
              <div class="m-l-auto flex" style="max-width: 340px;">
                <select class="form-control h-38" v-model.number="searchType">
                  <option value="2">訂單編號</option>
                  <option value="3" >物流查詢編號</option>
                </select>
                <div class="form-group h-38 m-l-5">
                  <div class="input-group h-38">
                    <input v-if="searchType == 2" class="form-control h-38" v-model="orderSN" type="text" style="min-width: 150px;">
                    <input v-if="searchType == 3" class="form-control h-38" v-model="venderOrderNo" type="text" style="min-width: 150px;">
                    <span class="input-group-addon c-pointer" @click="changePage(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="shippingInfo.overview">
            <ul>
              <li>訂單總金額：$ {{ shippingInfo.overview.total_money }}</li>
              <li>訂單總數：{{ shippingInfo.overview.total_amount }}</li>
              <li>物流總費用：$ {{ shippingInfo.overview.total_vendor_fee }}</li>
            </ul>
          </div>
          <div class="table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th v-if="getRoleType !== 10" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品牌名稱(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">門市名稱(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單來源</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂購人類型</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單編號</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">物流查詢編號</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易日期</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單總金額(元)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單折扣(元)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">物流費用(元)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">物流廠商</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">物流狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">距離</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">實際取貨時間</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">實際送達時間</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">預計取貨時間</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">預計送達時間</th>
                </tr>
              </thead>
              <tbody v-if="isLoading">
                <tr>
                  <td colspan="16" class="text-center">資料讀取中......</td>
                </tr>
              </tbody>
              <tbody v-else-if="!isLoading && shippingTableList.length > 0">
                <tr v-for="(row, index) in shippingTableList" :key="index" class="even" role="row">
                  <td class="sorting_1">
                    {{index + 1 }}
                  </td>
                  <td v-if="getRoleType !== 10" style="width: 200px">
                    {{row.brand_name}}({{row.brand_id}})
                  </td>
                  <td>
                    {{row.store_name}}({{row.store_id}})
                  </td>
                  <td>
                    {{row.source_type	|| '-'}}
                  </td>
                  <td>
                    {{row.user_type	|| '-'}}
                  </td>
                  <td>
                    {{row.order_sn || '-'}}
                  </td>
                  <td>
                    {{ row.customer_order_no || '-' }}
                  </td>
                  <td>
                    <label class="label" :class="row.order_status | orderStateColor">
                      {{row.order_status | orderStatusName}}
                    </label>
                  </td>
                  <td>
                    {{row.order_date || '-'}}
                  </td>
                  <td>
                    {{row.total_paid_money || 0}}
                  </td>
                  <td>
                    {{row.discount_money || 0}}
                  </td>
                  <td>
                    {{row.vendor_fee}}
                  </td>
                  <td>
                    {{ row.vendor_code | shippingVendorName }}
                  </td>
                  <td>
                    <label class="label" :class="row.shipping_status | shippingStateColor">
                      {{row.shipping_status | shippingStatusName}}
                    </label>
                  </td>
                  <td>
                    <!-- 公尺轉換為公里 & 取到小數點第二位 -->
                    {{row.distance || row.distance === 0 ? Math.round(row.distance / 1000 * 1000) / 1000 + '公里' : '-'}}
                  </td>
                  <td>
                    {{row.actual_get_time || '-'}}
                  </td>
                  <td>
                    {{row.actual_arrived_time || '-'}}
                  </td>
                  <td>
                    {{row.expected_get_time || '-'}}
                  </td>
                  <td>
                    {{row.expected_arrived_time || '-'}}
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="!isLoading && shippingTableList.length === 0">
                <tr style="background-color: white">
                  <td rowspan="1" colspan="16" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                    <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                    <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <paginate
            :pageAmount="shippingPageAmount"
            :total="pagination.shippingFlow.total"
            :isActive="isActive"
            :groupAmount="pagination.shippingFlow.groupAmount"
            :clickPage="changePage"
          />
        </div>
        <!-- 物流 - End -->

        <!-- 資訊服務費抽成 - Start -->
        <div v-if="typeSelect === 10">
          <div v-if="(getRoleType === 99 && !storeSelect.value) || commissionInfo.show_allow_void_commission_detail">
            <div v-if="getRoleType === 99 && !storeSelect.value">
              <span class="text-red">＊</span>
              下列對帳表不含獨立簽約門市的抽成資訊，如需檢視請先切換至該門市。
            </div>
            <div v-if="commissionInfo.show_allow_void_commission_detail">
              <span class="text-red">＊</span>
              每月作廢訂單額度於次月 4 日才會納入計算。
            </div>
            <br>
          </div>
          <!-- 搜尋條件 - Start -->
          <div class="row">
            <div v-if="brandBrief.length > 2 || storeBrief.length > 2" class="flex m-b-10">
              <!-- 品牌 -->
              <div class="inline-block from-group pull-left " v-if="brandBrief.length > 2" style="width: auto; min-width: 150px;">
                <multiselect
                  v-model="brandSelect"
                  :options="brandBrief"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  placeholder="==品牌=="
                  :show-labels="false"
                  :multiple="false"
                  label="label"
                  track-by="value"
                >
                </multiselect>
              </div>
              <!-- 門市 -->
              <div :class="['inline-block from-group pull-left', { 'm-l-5' : brandBrief.length > 2 }]" v-if="storeBrief.length > 2" style="width: auto; min-width: 150px;">
                <multiselect
                  v-model="storeSelect"
                  :options="storeBrief"
                  label="label"
                  :allow-empty="false"
                  :close-on-select="true"
                  placeholder="門市"
                  :show-labels="false"
                  :preselect-first="true"
                >
                </multiselect>
              </div>
            </div>
            <!-- 時間搜尋 - Start -->
            <div class="flex">
              <div class="form-group">
                <select class="form-control h-38" v-model="timeType" @change="changePage(1)">
                  <option v-for="(type) in timeTypeList" :key="`type-${type.value}`" :value="type.value">
                    {{ type.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <select class="form-control h-38" v-model="year" @change="changePage(1)">
                  <option v-for="(val) in yearList" :key="`year${val}`"  :value="val">
                    {{ val + '年' }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <select v-if="timeType === 'monthly'" class="form-control h-38" v-model="month" @change="changePage(1)">
                  <option v-for="(val) in 12" :key="`month${val}`"  :value="val">
                    {{ val + '月'}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <select v-if="timeType === 'quarterly'" class="form-control h-38" v-model="quarter" @change="changePage(1)">
                  <option v-for="(val) in quarterList" :key="`quarter${val.value}`" :value="val.value">
                    {{ val.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- 搜尋條件 - End -->
          <ul v-if="brandSelect.value" class="m-t-10">
            <!-- 顯示可扣除的作廢訂單 - Strat -->
            <template v-if="commissionInfo.show_allow_void_commission_detail">
              <li>
                資訊服務費抽成原金額(A)： ${{ commissionInfo.original_commission_money }}
              </li>
              <li>
                可扣除的作廢訂單(B)
                <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="以下訂時間，早下訂的先扣除">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                </span>
                ： {{ commissionInfo.allow_void_commission_amount  }}/{{ commissionInfo.allow_invalid_order_quota  }} 筆，共 ${{ commissionInfo.allow_void_commission_money }}
              </li>
              <li>
                當月資訊服務費抽成金額(A-B)： ${{ commissionInfo.total_commission_money }}
              </li>
            </template>
            <!-- 顯示扣除的作廢訂單 - End -->
            <template v-else>
              <li>
                資訊服務費抽成原金額： ${{ commissionInfo.original_commission_money }}
              </li>
            </template>
          </ul>
          <!-- 列表 - Start -->
          <div class="table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品牌(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">分店(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">實付總金額</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">已完成訂單資訊服務費抽成總金額</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">已作廢訂單資訊服務費抽成總金額</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">
                    資訊服務費抽成總金額
                    <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="已完成+已作廢訂單資訊服務費抽成金額">
                      <i class="fa fa-question-circle" aria-hidden="true"></i>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="isLoading">
                <tr>
                  <td colspan="12" class="text-center">資料讀取中......</td>
                </tr>
              </tbody>
              <tbody v-else-if="commissionList.length">
                <tr v-for="(row, index) in commissionList" :key="index" class="even" role="row">
                  <td class="sorting_1">
                    {{index + 1 }}
                  </td>
                  <td style="width: 200px">
                    {{row.brand_name}}({{row.brand_id}})
                  </td>
                  <td>
                    <router-link :to="{ path: `/commissionStore/${row.store_id}`, query: { year: year, type: timeType, period: timeType === 'quarterly' ? quarter : month }}">
                      {{row.store_name}}({{row.store_id}})
                    </router-link>
                  </td>
                  <td>
                    {{row.total_paid_money}}
                  </td>
                  <td>
                    {{row.total_finish_commission_money}}
                  </td>
                  <td>
                    {{row.total_void_commission_money}}
                  </td>
                  <td>
                    {{row.total_commission_money}}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr style="background-color: white">
                  <td rowspan="1" colspan="7" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                    <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                    <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <paginate
            :pageAmount="commissionPageAmount"
            :total="pagination.commission.total"
            :isActive="isActive"
            :groupAmount="pagination.commission.groupAmount"
            :clickPage="changePage"
          />
          <!-- 列表 - End -->
        </div>
        <!-- 資訊服務費抽成 - End -->
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { setSharedToken } from '../../../assets/js/shared-token.js'
  import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import moment from 'moment'
  export default {
    name: 'VenderTradeTable',
    components: {
      'date-time-picker': datetimePicker,
      'clip-loader': ClipLoader
    },
    data () {
      return {
        searchType: 2,
        pagination: {
          paymentFlow: {
            total: 84,
            count: 10,
            tableIndex: 1,
            pageGroup: 1,
            groupAmount: 10
          },
          shippingFlow: {
            total: 10,
            count: 10,
            tableIndex: 1,
            pageGroup: 1,
            groupAmount: 10
          },
          commission: {
            total: 84,
            count: 10,
            tableIndex: 1,
            pageGroup: 1,
            groupAmount: 10
          }
        },
        history: [],
        isLoading: false,
        storeBrief: [],
        brandBrief: [],
        brandSelect: {label: '== 品牌 ==', value: 0},
        storeSelect: {label: '== 門市 ==', value: 0},
        accountingList: [
          {label: '== 交易類型 ==', value: 999},
          {label: '收款', value: 1},
          {label: '退款', value: 2}
        ],
        reportType: [
          {label: '== 報表類型 ==', value: 999},
          {label: '原始報表', value: 1},
          {label: '對外對帳單', value: 2}
        ],
        userTypeList: [
          { label: '== 訂購人類型 ==', value: 999 },
          { label: '會員', value: 1 },
          { label: '訪客', value: 2 }
        ],
        sourceTypeList: [
          { label: '== 訂單來源 ==', value: 999 },
          { label: '你訂', value: 1 },
          { label: 'POS', value: 2 }
        ],
        accountingSelect: 999,
        tradeTypeSelect: 999,
        reportSelect: 999,
        userType: 999,
        sourceType: 999,
        dateoption: {
          type: 'day',
          week: ['一', '二', '三', '四', '五', '六', '日'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          placeholder: '',
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '24px',
            'font-size': '16px',
            'border': '1px solid #d2d6de',
            'border-radius': '0px 3px 3px 0px',
            'color': '#555',
            'text-align': 'left'
          },
          color: {
            header: '#dd4b39',
            headerText: '#fff'
          },
          buttons: {
            ok: '確定',
            cancel: '取消'
          },
          overlayOpacity: 0.5, // 0.5 as default
          dismissible: true // as true as default
        },
        menuTime: {
          start: {
            time: moment().format('YYYY-MM-DD')
          },
          end: {
            time: moment().format('YYYY-MM-DD')
          }
        },
        startLimit: [
          {
            type: 'fromto',
            to: moment().add(1, 'days').format('YYYY-MM-DD')
          }
        ],
        endLimit: [
          {
            type: 'fromto',
            to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
          }
        ],
        typeSelect: 99,
        isDownloading: false,
        orderSN: null,
        venderOrderNo: null,
        retry: 0,
        retryTimer: null,
        retryFrequency: 0,
        sourceSelect: 999,
        hasIndependentReport: 0, // 門市是否獨立產出報表 (門市權限)
        // 物流
        shippingVendorSelect: 999,
        shippingVendorList: [],
        orderStatus: 999,
        orderStatusList: [
          {label: '== 訂單狀態 ==', value: 999},
          {label: '訂單已送出，尚未付款', value: 1},
          {label: '付款中', value: 2},
          {label: '訂單已付款，尚未通知店家', value: 3},
          {label: '客人取消', value: 99},
          {label: '未接單', value: 100},
          {label: '已接單', value: 110},
          {label: '店家退訂', value: 120},
          {label: '系統退訂', value: 121},
          {label: '已取消', value: 122},
          {label: '已完成', value: 130},
          {label: '已作廢', value: 140}
        ],
        shippingStatus: 999,
        shippingStatusList: [
          {label: '== 物流狀態 ==', value: 999},
          {label: '成立物流單', value: 100},
          {label: '物流接單', value: 110},
          {label: '已分派外送員', value: 120},
          {label: '已取貨', value: 130},
          {label: '已送達', value: 140},
          {label: '門市取消叫件', value: 900},
          {label: '媒合失敗', value: 920}
        ],
        shippingInfo: {},
        shippingTableList: [],
        // 資訊服務費抽成 Data
        commissionList: [], // 列表
        commissionInfo: {}, // 資訊服務費抽成資訊
        timeType: 'monthly',
        timeTypeList: [
          { name: '月', value: 'monthly' },
          { name: '季', value: 'quarterly' }
        ],
        year: null,
        yearList: [],
        month: 0,
        quarter: null,
        quarterList: [
          { name: '1-3月 (Q1)', value: '1' },
          { name: '4-6月 (Q2)', value: '2' },
          { name: '7-9月 (Q3)', value: '3' },
          { name: '10-12月 (Q4)', value: '4' }
        ]
      }
    },
    computed: {
      ...mapGetters(['getRoleType', 'getTradeType', 'getRestricted']),
      paymentPageAmount () {
        return Math.ceil(this.pagination.paymentFlow.total / this.pagination.paymentFlow.count)
      },
      shippingPageAmount () {
        return Math.ceil(this.pagination.shippingFlow.total / this.pagination.shippingFlow.count)
      },
      commissionPageAmount () {
        return Math.ceil(this.pagination.commission.total / this.pagination.commission.count)
      },
      getDataH () {
        return this.$parent.getDataH
      },
      traceTypeOption () {
        return this.getTradeType.filter(x => x.value !== 1)
      },
      getFile () {
        return this.$parent.getFile
      },
      showHistoryReport () {
        if (this.typeSelect === 10) {
          if (this.getRoleType === 99) {
            // 有選擇品牌但無選擇門市 or 此門市可獨立產出報表(品牌權限選門市則不顯示)
            return (this.brandSelect.value && !this.storeSelect.value) || (this.storeSelect.value && this.hasIndependentReport)
          } else if (this.getRoleType === 30) {
            return this.brandSelect.value && !this.storeSelect.value
          } else if (this.getRoleType === 10) {
            return this.storeSelect.value && this.hasIndependentReport
          }
        }
        return false
      }
    },
    created () {
      if (this.$route.query.typeSelect) {
        this.typeSelect = Number(this.$route.query.typeSelect)
      }
      this.getBrandBrief()
      this.setCommissionDefault()
      this.getShippingVendorList()
    },
    methods: {
      getBrandBrief () {
        // 取得品牌列表
        const url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
        this.brandBrief = [{ label: '== 品牌 ==', value: 0 }]
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            let bList = response.data.list
            for (let i = 0; i < bList.length; i++) {
              let obj = { label: bList[i].name, value: bList[i].brand_id }
              if (!bList[i].is_visible) {
                obj.label = obj.label + ' (測)'
              }
              this.brandBrief.push(obj)
              if (i === 0) {
                if (this.getRoleType === 10 || bList.length === 1) {
                  this.brandSelect.label = obj.label
                  this.brandSelect.value = obj.value
                }
              }
            }
            if (this.getRoleType === 30 || this.getRoleType === 99) {
              this.changePage(1)
            }
          }
        })
      },
      getStoreBrief (brandId) {
        console.log('getStoreBrief | VenderTradeTable')
        // 取得門市列表
        this.storeSelect = {label: '== 門市 ==', value: 0}
        this.storeBrief = [{label: '== 門市 ==', value: 0}]
        if (!brandId) return

        const url = '/brand/' + brandId + '/storeListBrief?list_sort=name ASC'
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            let sList = response.data.list
            for (let i = 0; i < sList.length; i++) {
              let obj = { label: sList[i].name, value: sList[i].store_id }
              this.storeBrief.push(obj)
            }
            if (this.getRoleType === 10) {
              if (this.storeBrief.length === 2) {
                this.storeSelect.value = sList[0].store_id
                this.getStoreInfo() // 查詢是否為門市獨立報表
              }
              this.changePage(1)
            }
          }
        })
      },
      getShippingVendorList () {
        // 取得物流廠商
        const url = '/platform/shippingVendorList?type=3' // type => 直串物流：1 / 米特物流：2 / 含全球物流：3
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.shippingVendorList = response.data.list
            this.shippingVendorList.sort(function (a, b) {
              return a.sort - b.sort
            })
            this.shippingVendorList = this.shippingVendorList.map(item => {
              return { label: this.$options.filters.shippingVendorName(item.vendor_code), value: item.vendor_code }
            })
            this.shippingVendorList.unshift({label: '== 物流廠商 == ', value: 999})
          }
        })
      },
      changePage (index) {
        // 改變當前頁
        if (this.typeSelect === 99) {
          this.pagination.paymentFlow.tableIndex = index
          this.getList()
        } else if (this.typeSelect === 1) {
          this.pagination.shippingFlow.tableIndex = index
          this.getShippintTableList()
        } else if (this.typeSelect === 10) {
          this.pagination.commission.tableIndex = index
          this.getCommissionList()
        }
      },
      isActive (index) {
        if (this.typeSelect === 99) {
          return this.pagination.paymentFlow.tableIndex === index
        } else if (this.typeSelect === 1) {
          return this.pagination.shippingFlow.tableIndex === index
        } else if (this.typeSelect === 10) {
          return this.pagination.commission.tableIndex === index
        }
        return false
      },
      getStoreInfo () {
        // 僅在門市權限時判斷
        // 判斷門市是否為獨立產出報表
        if (this.storeSelect.value) {
          const url = 'store/' + this.storeSelect.value + '/info'
          this.getDataH('get', url, null, (response) => {
            if (response.data.status === 200) {
              this.hasIndependentReport = response.data.info.order_commission_setting ? response.data.info.order_commission_setting.has_independent_report : 0
            }
          })
        }
      },
      setQuery (noPage) {
        // 設定 API 參數
        let query = {}
        if (this.brandSelect.value && this.getRoleType !== 10) {
          query.brand_id = this.brandSelect.value
        }
        if (this.storeSelect.value && this.storeSelect.value !== 0) {
          query.store_id = this.storeSelect.value
        }
        if (this.typeSelect === 99) {
          // 金流
          if (!noPage) {
            query.page = this.pagination.paymentFlow.tableIndex
            query.size = this.pagination.paymentFlow.count
          }
          if (this.menuTime.start.time) {
            query.start_trade_date = moment(this.menuTime.start.time).format('YYYYMMDD')
          }
          if (this.menuTime.end.time) {
            query.end_trade_date = moment(this.menuTime.end.time).format('YYYYMMDD')
          }
          if (this.searchType === 2 && this.orderSN) {
            query.order_sn = this.orderSN
          }
          if (this.searchType === 3 && this.venderOrderNo) {
            query.customer_order_no = this.venderOrderNo
          }
          if (this.accountingSelect && this.accountingSelect !== 999) {
            query.accounting_type = this.accountingSelect
          }
          if (this.tradeTypeSelect && this.tradeTypeSelect !== 999) {
            query.trade_type = this.tradeTypeSelect
          }
          if (this.sourceSelect && this.sourceSelect !== 999) {
            query.order_sub_src_type = this.sourceSelect
          }
        } else if (this.typeSelect === 1) {
          // 物流
          if (!noPage) {
            query.page = this.pagination.shippingFlow.tableIndex
            query.size = this.pagination.shippingFlow.count
          }
          if (this.sourceType && this.sourceType !== 999) query.source_type = this.sourceType
          if (this.userType && this.userType !== 999) query.user_type = this.userType
          if (this.shippingVendorSelect && this.shippingVendorSelect !== 999) {
            query.vendor_code = this.shippingVendorSelect
          }
          if (this.orderStatus && this.orderStatus !== 999) {
            query.order_status = this.orderStatus
          }
          if (this.shippingStatus && this.shippingStatus !== 999) {
            query.shipping_status = this.shippingStatus
          }
          if (this.menuTime.start.time) {
            query.start_date = moment(this.menuTime.start.time).format('YYYY-MM-DD')
          }
          if (this.menuTime.end.time) {
            query.end_date = moment(this.menuTime.end.time).format('YYYY-MM-DD')
          }
          if (this.searchType === 2 && this.orderSN) {
            query.order_sn = this.orderSN
          }
          if (this.searchType === 3 && this.venderOrderNo) {
            query.customer_order_no = this.venderOrderNo
          }
        } else if (this.typeSelect === 10) {
          // 資訊服務費抽成
          if (!this.noPage) {
            query.page = this.pagination.commission.tableIndex
            query.size = this.pagination.commission.count
            query.list_type = this.timeType
            query.year = this.year
          }
          if (this.timeType === 'quarterly') {
            query.quarter = this.quarter
          } else {
            query.month = this.month
          }
        }
        return new URLSearchParams(query).toString()
      },
      getList () {
        // 取得列表
        if (!this.setQuery(false)) return
        this.isLoading = true
        const url = 'accounting/history/list?' + this.setQuery(false)
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.history = response.data.list
            this.pagination.paymentFlow.total = response.data.total
            this.$router.replace({ path: this.$route.path, query: {typeSelect: this.typeSelect} })
          }
          this.isLoading = false
        })
      },
      getShippintTableList () {
        // 取得物流訂單列表
        if (!this.setQuery(false)) return
        this.isLoading = true
        let url = 'shipping/report/list?' + this.setQuery(false)
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.shippingInfo = response.data
            this.shippingTableList = response.data.list
            this.pagination.shippingFlow.total = response.data.total
            this.$router.replace({ path: this.$route.path, query: {typeSelect: this.typeSelect} })
          }
          this.isLoading = false
        })
      },
      getCommissionList () {
        // 取得資訊服務費抽成列表
        if (!this.setQuery(false)) return
        this.isLoading = true
        let url = 'orderCommission/history/list?' + this.setQuery(false)
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.commissionInfo = response.data
            this.commissionList = response.data.list
            this.pagination.commission.total = response.data.total
            this.$router.replace({ path: this.$route.path, query: {typeSelect: this.typeSelect} })
          }
          this.isLoading = false
        })
      },
      download () {
        // 下載報表
        if (this.typeSelect === 99) {
          // 金流 -> 排程
          this.exportScheduleFile()
        } else {
          // 物流、抽成 -> 直接下載
          this.exportFile()
        }
      },
      exportScheduleFile () {
        // 下載排程報表
        if (!this.setQuery(true)) return
        this.isDownloading = true
        let url = 'accounting/history/listSheetsSchedule?' + this.setQuery(true)

        this.getDataH('get', url, null, (response) => {
          if (response.data.sche_info.status === 3) {
            this.isDownloading = false
            this.retry = 0
            let a = document.createElement('a')
            a.href = response.data.sche_info.file_url
            a.download = '訂單列表_' + moment().format('YYYY_MM_DD') + '.zip'
            document.body.appendChild(a)
            a.click()
            clearTimeout(this.retryTimer)
            this.retryFrequency = 0
          } else if (response.data.sche_info.status === 9) {
            this.isDownloading = false
            if (this.retryFrequency > 3) {
              alert('請聯絡客服或等24小時候再試')
              return false
            }
            let yes = confirm('輸出未完成，請聯絡客服或再試一次。')
            if (yes) {
              this.retryFrequency++
            }
            clearTimeout(this.retryTimer)
          } else {
            this.retry = 1
            this.retryTimer = setTimeout(this.exportScheduleFile, 6000)
          }
        })
      },
      exportFile () {
        // 直接下載報表 (非排程)
        if (!this.setQuery(true)) return

        this.isDownloading = true
        let url = ''
        let text = ''
        if (this.typeSelect === 10) {
          url = 'orderCommission/history/listSheets?' + this.setQuery(true)
          const timeName = this.timeType === 'quarterly' ? `Q${this.quarter}` : this.month.toString().padStart(2, '0')
          const brandName = this.brandSelect.value ? this.brandSelect.label + '_' : ''
          text = brandName + `資訊服務費抽成對帳表_${this.year}_${timeName}.xlsx`
        } else if (this.typeSelect === 1) {
          url = 'shipping/report/listSheets?' + this.setQuery(true)
          text = '廠商對帳紀錄表_物流.xlsx'
        }
        this.getFile('get', url, null, (response) => {
          this.isDownloading = false
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let objectUrl = URL.createObjectURL(blob)
          let name = ''
          let a = document.createElement('a')
          name = text
          a.download = name
          a.href = objectUrl
          document.body.appendChild(a)
          a.click()
        })
      },
      setCommissionDefault () {
        // 設定資訊服務費抽成初始值
        const nowYear = new Date().getFullYear()
        for (let y = nowYear; y >= 2022; y--) {
          // 從 2022 開始的年份
          this.yearList.push(y)
        }
        this.year = nowYear
        this.month = new Date().getMonth() + 1
        this.quarter = Math.ceil(this.month / 3)
      },
      goCommissionHistory () {
        // 前往抽成歷史報表
        let query = {}
        if (this.brandSelect.value) {
          query.brand_id = this.brandSelect.value
        }
        if (this.storeSelect.value) {
          query.store_id = this.storeSelect.value
        }
        this.$router.push({ name: 'commissionHistory', query: query })
      },
      goCommissionStore (storeId) {
        // 前往分店訂單列表
        if (!storeId) return
        this.$router.push({ path: '/commissionStore/' + storeId })
      },
      openLink () {
        window.open(this.shippingInfo.mete_portal_url, '_blank')
      },
      creditCardType (val) {
        // 支付別
        switch (val) {
          case 0:
            return '-'
          case 1:
            return '<img src="/static/img/visa.png">'
          case 2:
            return '<img src="/static/img/master-card.png">'
          case 3:
            return '<img src="/static/img/jcb.png">'
          case 4:
            return '<img src="/static/img/union-pay.png">'
          case 5:
            return '<img src="/static/img/american-express.png">'
          case 6:
            return '<img src="/static/img/debit-card.png">'
          default:
            return '-'
        }
      },
      tradeType (type) {
        // 付款類型
        if (type === 1) {
          return '現金'
        } else if (type === 706) {
          return '信用卡'
        } else if (type === 707) {
          return 'LINE PAY'
        } else if (type === 701) {
          return 'iPASS MONEY'
        } else if (type === 709) {
          return '信用卡(台新)'
        } else if (type === 710) {
          return '信用卡'
        } else if (type === 713) {
          return '台灣Pay'
        } else if (type === 716) {
          return '全盈+PAY'
        } else if (type === 717) {
          return '悠遊付'
        } else if (type === 718) {
          return 'Pi 拍錢包'
        } else if (type === 719) {
          return '全支付'
        } else if (type === 720) {
          return 'icash Pay'
        } else if (type === 908) {
          return '街口支付'
        } else if (type === 909) {
          return '遠傳電信代收'
        }
      },
      tradeTypeColor (name) {
        // 付款類型顏色
        if (name.indexOf('現金') > -1) {
          return 'label-default'
        } else if (name.indexOf('LINE') > -1) {
          return 'label-success'
        } else if (name.indexOf('iP') > -1) {
          return 'label-success'
        } else if (name.indexOf('台新') > -1) {
          return 'label-primary'
        } else if (name.indexOf('國泰') > -1) {
          return 'label-primary'
        } else if (name.indexOf('街口') > -1) {
          return 'label-danger'
        } else if (name.indexOf('Pi') > -1) {
          return 'label-info'
        } else if (name.indexOf('全盈') > -1) {
          return 'label-primary'
        } else if (name.indexOf('台灣') > -1) {
          return 'label-warning'
        } else if (name.indexOf('icash') > -1) {
          return 'label-info'
        } else if (name.indexOf('遠傳') > -1) {
          return 'label-danger'
        } else if (name.indexOf('悠遊付') > -1) {
          return 'label-primary'
        } else {
          return 'label-warning'
        }
      },
      accountingType (val) {
        // 交易類型顏色
        switch (val) {
          case 1:
            return 'label-success'
          case 2:
            return 'label-danger'
        }
      },
      goto () {
        setSharedToken(window.localStorage.getItem(this.$config.token))
        window.location.href = `${this.$config.bdms}financial/account-record/vender`
      }
    },
    watch: {
      'typeSelect' (val) {
        this.searchType = 2
        switch (val) {
          case 99:
            this.getList()
            break
          case 1:
            this.getShippintTableList()
            break
          case 10:
            this.getCommissionList()
        }
      },
      'brandSelect.value' (val) {
        this.getStoreBrief(val)
        this.changePage(1)
      },
      'storeSelect.value' (val) {
        this.changePage(1)
        if (this.typeSelect === 10 && val) {
          this.getStoreInfo() // 查詢是否為門市獨立報表
        }
      },
      'menuTime.end.time' () {
        const lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
        if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
        this.startLimit = [
          {
            type: 'fromto',
            to: lastDay
          }
        ]
        this.changePage(1)
      },
      'menuTime.start.time' () {
        const lastDay = moment(this.menuTime.start.time).add('30', 'days')
        if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
        else this.menuTime.end.time = moment().format('YYYY-MM-DD')
        this.endLimit = [
          {
            type: 'fromto',
            from: moment(this.menuTime.start.time).subtract(1, 'days'),
            to: moment().add(1, 'days')
          }
        ]
        this.changePage(1)
      },
      'tradeTypeSelect' (val) {
        if (val !== 713) {
          this.reportSelect = 1
        }
        if (val !== 908) {
          this.sourceSelect = 1
        }
      }
    }
  }
</script>

<style scoped>
.m-b-10 {
  margin-bottom: 10px;
}
.m-l-auto{
  margin-left: auto;
}
.p-a-10 {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// index.vue?780a7ab7